import { render, staticRenderFns } from "./MovimentacoesForm.vue?vue&type=template&id=9995a670&scoped=true&"
import script from "./MovimentacoesForm.vue?vue&type=script&lang=js&"
export * from "./MovimentacoesForm.vue?vue&type=script&lang=js&"
import style0 from "./MovimentacoesForm.vue?vue&type=style&index=0&id=9995a670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9995a670",
  null
  
)

export default component.exports